import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=e4bc4322&"
import script from "./Pagos.vue?vue&type=script&lang=js&"
export * from "./Pagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports